import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useLanguage } from "../lib/LanguageContext";
import { APP_ROUTES } from "../routing/routes";
import { cn } from "../lib/cn";
const links = [
    { to: APP_ROUTES.admin, key: "users" },
    { to: APP_ROUTES.adminLimits, key: "limits" },
];
export const AdminNav = () => {
    const { t } = useLanguage();
    const location = useLocation();
    return (_jsx("nav", { className: "mb-6 flex flex-col gap-1", "aria-label": t("admin.navLabel"), children: links.map((link) => (_jsx(Link, { to: link.to, className: cn("rounded-md px-3 py-2 text-sm font-medium transition", location.pathname === link.to
                ? "bg-purple-100 text-purple-800 dark:bg-purple-950/50 dark:text-purple-200"
                : "text-muted-foreground hover:bg-muted hover:text-foreground"), children: t(`admin.nav.${link.key}`) }, link.to))) }));
};
